import React, { useContext, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
// import { CloseButton } from 'components/common/Toast';
import { BrowserRouter as Router } from 'react-router-dom';
import is from 'is_js';
import AppContext from 'context/Context';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import AppRoutes from 'routes';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);


  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppRoutes />
      {/* <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.TOP_CENTER}
      />{' '} */}
    </Router>
  );
};

export default App;
